/**
 * When the Tier 3 comment assist may be offered (design §8).
 *
 * Its own module, and pure, for the same reason `outboxRules` is: this is the
 * rule that decides whether an auditor is shown a button, and a button offered
 * where it cannot work is worse than no button at all. Somebody on a plant
 * floor who presses it and gets an error learns the feature is broken, and
 * they are not wrong — they just learn it about the whole feature rather than
 * about the network.
 *
 * The card imports this. A test can too, without pulling in the HTTP layer.
 */

/** Only these two answers owe an explanation, and only they have a finding. */
export const isGap = (a) => a === "no" || a === "partial";

/**
 * Should the "Tidy this up" control be shown at all?
 *
 * Four conditions, each for a different reason:
 *
 *   · `enabled` — the server's switch. It is an environment variable the
 *     browser cannot see, so the audit payload carries the answer.
 *   · `online`  — and separately, because a cached audit opened offline still
 *     carries `assist_enabled` from whenever it was fetched. The assist is
 *     deliberately never queued: a suggestion that arrives an hour later at a
 *     different machine is worse than none.
 *   · `note`    — the tier is "tidy what you wrote". A button on an empty box
 *     invites somebody to expect it to write the note for them, which is the
 *     one thing it must never do.
 *   · answer and `disabled` — a Yes has no finding to write up, and a
 *     submitted audit is not editable.
 */
export function shouldOfferAssist({ enabled, online, disabled, answer, note } = {}) {
  if (!enabled) return false;
  if (!online) return false;
  if (disabled) return false;
  if (!isGap(answer)) return false;
  return !!String(note == null ? "" : note).trim();
}
